import Colors from "@cosine/lib/Colors";
import { DoubleSide, Group, Material, Mesh, MeshBasicMaterial, Object3D, PlaneGeometry, Texture } from "three";

export interface IsoGroundOptions {
  texture?: Texture,
  size?: number,
}

export default class IsoGround {
  geometry: PlaneGeometry;
  material: Material;
  mesh: Mesh;

  constructor (parent: Object3D, options: IsoGroundOptions) {
    const size = options.size || 100;

    const grid = new Group();
    this.geometry = new PlaneGeometry(size, size, size, size);
    this.material = new MeshBasicMaterial({
      color: Colors.grey50,
      side: DoubleSide,
    });
    this.mesh = new Mesh(
      this.geometry,
      this.material,
    );
    this.mesh.receiveShadow = false;

    grid.position.y = -0.01;
    grid.rotation.x = Math.PI / 2;
    grid.add(this.mesh);

    parent.add(grid);
  }

  dispose () {
    this.mesh.removeFromParent();
    this.geometry.dispose();
    this.material.dispose();
  }
}
